import { defineMessages } from "react-intl";

export default defineMessages({
  scoutTitle: {
    id: "ScoutCard.soutTitle",
    defaultMessage: "Scouting",
  },
  scoutCaption: {
    id: "ScoutCard.scoutCaption",
    defaultMessage: `{n, plural,
      one {prospect being tracked}
      other {prospects being tracked}
    }`,
  },
});
